import React, { useEffect, useState } from 'react';
import { Button, Header, Input, Modal, Table } from 'react-frontier';
import { useTranslation } from 'react-i18next';
import { EventDateMetadata, Metadata } from '../SiteClasses';
import API from '../API';
import { getMetadataTypeName } from '../SiteUtil';

interface AddMetadataModalProps{
	open: boolean,
	onClose: ()=>void,
	onAdd: (metadata: EventDateMetadata)=>boolean,
	date_id: number,
}

var AddMetadataModal = (props: AddMetadataModalProps)=>{
	var [metadata, setMetadata] = useState<Metadata[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(!props.date_id || !props.open) return;
		setMetadata(null);
		API.getAvailableMetadata(props.date_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setMetadata(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error inesperado cargando las preguntas (LCL-AMTMD-1)');
		});
	}, [props.open, props.date_id]);

	var onSelected = (metadata: Metadata)=>{
		return ()=>{
			if(!props.onAdd) return;
			var added = props.onAdd({
				...metadata,
				value: null,
				value_id: null,
			});
			if(added) props.onClose();
		}
	}
	
	return <Modal open={props.open} onClose={props.onClose} size='tiny'>
		<Modal.Header text='Agregar pregunta' />
		<Modal.Content>
			{!metadata ? (
				<Header loading text={'Cargando datos'} />
			) : (
				<Table fitted striped
					className='last'
					headers={['ID', 'Pregunta', 'Tipo']}	
				>
					{metadata.length==0 ? (
						<Table.Cell row empty>No hay preguntas disponibles para agregar</Table.Cell>
					) : metadata.map(a=>(
						<Table.Row key={`mtd-${a.metadata_id}`} selectable onClick={onSelected(a)}>
							<Table.Cell collapsing>{a.metadata_id}</Table.Cell>
							<Table.Cell>
								<div>{a.metadata_name}</div>
								{!!a.metadata_comment && (
									<div style={{ fontSize: 12, color: 'gray', lineHeight: '10px' }}>{a.metadata_comment}</div>
								)}
							</Table.Cell>
							<Table.Cell collapsing>
								{getMetadataTypeName(a.type_id)}
							</Table.Cell>
						</Table.Row>
					))}
				</Table>
			)}
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default AddMetadataModal;